import BaseModelAPI from '../BaseModelAPI';

export default class PickingSupplyForProductionDetail extends BaseModelAPI {
	static entity = 'pickingsupplyforproductiondetail';
	static entityName = 'pickingsupplyforproductiondetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.pickingSupplyForProductionId = '';
			this.pickingSupplyForProduction = {};
			this.materialPartId = '';
			this.materialPart = {};
			this.partId = '';
			this.part = {};
			this.qtySupply = 0;
			this.qtyOutstanding = 0;
			this.remark = '';
			this.documentStatusId = '';
			this.documentStatus = {};
			this.workOrderSupplyDetailId = '';
			this.workOrderSupplyDetail = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
			this.materialPartCombination = '';
	/*END_APP_MODEL_DEFINITION*/
	}

	static async getListByPartCombination(this_, filter, sorting, pageIndex, pageSize, persistBy) {
		let filterArray = Array();
		if (filter != null && filter != undefined) {
			// console.log(filter);
			filterArray = this.getFilter(filter);
		}
		if (sorting != null && sorting != undefined) {
			Object.entries(sorting).map(([key, value]) => {
				if (key != '') {
					filterArray.push("sorting[" + key + "]=" + (value ? "1" : "0"));     // draftFromUpload & draftMode
				}
			});

		}
		if (pageIndex != null) {
			filterArray.push("pageIndex=" + pageIndex);
		}
		if (pageSize != null) {
			filterArray.push("pageSize=" + pageSize);
		}
		let params = "";
		if (filterArray.length > 0) {
			params = "?" + filterArray.join("&");
		}

		//DEBUG

		return this_.$http.get(`${this.entityName}/getlistbypartcombination` + params)
			.then(response => {
				if (response != null) {
					return response.data;
				}
				return response;
			})
			.catch(function (error) {
				if (error.response && error.response.data && error.response.data.errors) {
					const errors = error.response.data.errors;
					// Iterasi melalui setiap pesan kesalahan
					Object.keys(errors).forEach(key => {
						const errorMessages = errors[key];
						errorMessages.forEach(errorMessage => {
							// Tampilkan pesan kesalahan dalam toast
							this_.toast({message: errorMessage, title: 'Error', variant: 'danger'});
						});
					});
				}
				// this_.$store.dispatch('addErrorMessageGlobal', error);
				// throw error;
			});
	}

	static async GetSuggestionList(this_, id) {
		return this_.$http.get(`${this.entityName}/suggestionlist/${id}`)
		.then(response => {
			return response.data;
		})
		.catch(function(error){
			if (error.response && error.response.data && error.response.data.errors) {
				const errors = error.response.data.errors;
				// Iterasi melalui setiap pesan kesalahan
				Object.keys(errors).forEach(key => {
					const errorMessages = errors[key];
					errorMessages.forEach(errorMessage => {
						// Tampilkan pesan kesalahan dalam toast
						this_.toast({message: errorMessage, title: 'Error', variant: 'danger'});
					});
				});
			}
			// this_.$store.dispatch('addErrorMessageGlobal', error);
			// throw error;
		});
	}

	static async GetPickingCaseList(this_, pickingId, pickingDetailId) {
		return this_.$http.get(`${this.entityName}/pickingcaselist/${pickingId}/${pickingDetailId}`)
		.then(response => {
			return response.data;
		})
		.catch(function(error){
			if (error.response && error.response.data && error.response.data.errors) {
				const errors = error.response.data.errors;
				// Iterasi melalui setiap pesan kesalahan
				Object.keys(errors).forEach(key => {
					const errorMessages = errors[key];
					errorMessages.forEach(errorMessage => {
						// Tampilkan pesan kesalahan dalam toast
						this_.toast({message: errorMessage, title: 'Error', variant: 'danger'});
					});
				});
			}
			// this_.$store.dispatch('addErrorMessageGlobal', error);
			// throw error;
		});
	}

	static async ValidateScanCase(this_, pickingDetailId, controlCardId) {
        return this_.$http.get(`${this.entityName}/validateScanCase/${pickingDetailId}/${controlCardId}`)
        .then(response => {
            return response.data;
        })
        .catch(function(error){
			this_.CaseNo = "";
			if (error.response && error.response.data && error.response.data.errors) {
				const errors = error.response.data.errors;
				// Iterasi melalui setiap pesan kesalahan
				Object.keys(errors).forEach(key => {
					const errorMessages = errors[key];
					errorMessages.forEach(errorMessage => {
						// Tampilkan pesan kesalahan dalam toast
						this_.toast({message: errorMessage, title: 'Error', variant: 'danger'});
					});
				});
			}
            // this_.$store.dispatch('addErrorMessageGlobal', error);
            // throw error;
        });
    }

	static async ValidateSuggestion(this_, pickingDetailId, controlCardId, isConfirm) {
        return this_.$http.get(`${this.entityName}/validateSuggestion/${pickingDetailId}/${controlCardId}/${isConfirm}`)
        .then(response => {
            return response.data;
        })
        .catch(function(error){
			this_.CaseNo = "";
			if (error.response && error.response.data && error.response.data.errors) {
				const errors = error.response.data.errors;
				// Iterasi melalui setiap pesan kesalahan
				Object.keys(errors).forEach(key => {
					const errorMessages = errors[key];
					errorMessages.forEach(errorMessage => {
						// Tampilkan pesan kesalahan dalam toast
						this_.toast({message: errorMessage, title: 'Error', variant: 'danger'});
					});
				});
			}
            // this_.$store.dispatch('addErrorMessageGlobal', error);
            // throw error;
        });
    }

	static async AddPickingCase(this_, pickingDetailId, controlCardId) {
        return this_.$http.get(`${this.entityName}/addPickingCase/${pickingDetailId}/${controlCardId}`)
        .then(response => {
            return response.data;
        })
        .catch(function(error){
			this_.CaseNo = "";
			if (error.response && error.response.data && error.response.data.errors) {
				const errors = error.response.data.errors;
				// Iterasi melalui setiap pesan kesalahan
				Object.keys(errors).forEach(key => {
					const errorMessages = errors[key];
					errorMessages.forEach(errorMessage => {
						// Tampilkan pesan kesalahan dalam toast
						this_.toast({message: errorMessage, title: 'Error', variant: 'danger'});
					});
				});
			}
            // this_.$store.dispatch('addErrorMessageGlobal', error);
            // throw error;
        });
    }

	static async deleteDataPickingCase(this_, id) {
        return this_.$http.delete(`${this.entityName}/deletePickingCase/${id}`, {
            delete: id,

        }).catch(function(error){
			this_.CaseNo = "";
			if (error.response && error.response.data && error.response.data.errors) {
				const errors = error.response.data.errors;
				// Iterasi melalui setiap pesan kesalahan
				Object.keys(errors).forEach(key => {
					const errorMessages = errors[key];
					errorMessages.forEach(errorMessage => {
						// Tampilkan pesan kesalahan dalam toast
						this_.toast({message: errorMessage, title: 'Error', variant: 'danger'});
					});
				});
			}
            // this_.$store.dispatch('addErrorMessageGlobal', error);
            // throw error;
        });;
    }

}